// Constantes usadas em toda a página Usuarios.
// Extraídas para desafogar Usuarios.jsx e permitir teste unitário isolado dos presets.

// Lista completa de permissões granulares suportadas pelo backend (`perms` no user document).
// Cada `k` é a chave usada em `user.permissions`; `l` é o rótulo exibido na UI.
export const PERMS = [
  { k: "view_dashboard", l: "Ver Dashboard" },
  { k: "view_financeiro", l: "Ver Faturamento/Ticket Médio" },
  { k: "view_logistica", l: "Ver Logística" },
  { k: "view_empresas", l: "Ver Cadastro de Empresas" },
  { k: "manage_cadastros", l: "Gerenciar Todos os Cadastros" },
  { k: "cadastro_entregadores", l: "  · Cadastro de Entregadores" },
  { k: "cadastro_bairros", l: "  · Cadastro de Bairros" },
  { k: "cadastro_regioes", l: "  · Cadastro de Regiões" },
  { k: "cadastro_tipos_entrega", l: "  · Cadastro de Tipos de Entrega" },
  { k: "cadastro_formas_pgto", l: "  · Cadastro de Formas de Pgto" },
  { k: "manage_users", l: "Gerenciar Usuários" },
  { k: "view_reports", l: "Ver Relatórios" },
  { k: "create_entregas", l: "Criar Entregas" },
  { k: "change_status", l: "Alterar Status" },
  { k: "delete_entregas", l: "Excluir Entregas" },
  { k: "backup", l: "Backup/Restore" },
  { k: "config_horario", l: "Configurar Horário" },
  { k: "select_empresa", l: "Selecionar Empresa" },
  { k: "view_audit", l: "Ver Auditoria" },
];

// Presets built-in de permissões para acelerar cadastros. Custom presets vêm de /api/perm-presets.
export const PERM_PRESETS = [
  {
    k: "somente_leitura",
    l: "Somente leitura",
    hint: "Só visualiza dashboard, logística, relatórios e auditoria — sem editar nada",
    perms: ["view_dashboard", "view_logistica", "view_reports", "view_audit"],
  },
  {
    k: "operador_basico",
    l: "Operador básico",
    hint: "Cria entregas e altera status. Sem financeiro e sem cadastros",
    perms: ["view_dashboard", "create_entregas", "change_status", "view_reports"],
  },
  {
    k: "caixa_completo",
    l: "Caixa completo",
    hint: "Operador básico + financeiro (faturamento/ticket) + backup e config de horário",
    perms: ["view_dashboard", "view_financeiro", "view_reports", "create_entregas", "change_status", "backup", "config_horario"],
  },
  {
    k: "gerente_loja",
    l: "Gerente de loja",
    hint: "Quase tudo — dashboard, financeiro, cadastros e relatórios. Sem gestão de usuários nem exclusão",
    perms: ["view_dashboard", "view_financeiro", "view_logistica", "view_empresas", "view_reports", "view_audit",
      "manage_cadastros", "cadastro_entregadores", "cadastro_bairros", "cadastro_regioes", "cadastro_tipos_entrega", "cadastro_formas_pgto",
      "create_entregas", "change_status", "config_horario", "select_empresa"],
  },
];

// Estado inicial do formulário "Novo usuário".
export const initialUserForm = {
  nome: "", email: "", senha: "", username: "",
  role: "operador",
  permissions: ["create_entregas", "change_status"],
  perms_matrix: {},
  entregador_id: "",
  empresa_ids: [],
};
